export const chat = {
  copyMessage: "Copy message",
  reprompt: "Reprompt",
  placeholder: "Type your message...",
  loadMoreMessages: "Load more messages",
  editSystemPrompt: "Edit system prompt",
  messageCopied: "Message copied",
  dashboard: {
    title: "Dashboard",
  },
  chat: {
    title: "Chat",
  },
  modelSelect: {
    modelHelpText: "Select model",
    providerHelpText: "Select provider",
  },
  slides: {
    helpText: "Configure slide generation",
    numSlides: "Number of slides",
    template: "Slide template",
  },
  types: {
    basic: "Basic Chat",
    multiChat: "Comparative Chat",
    generationChat: "AI Generation Chat",
    imageGeneration: "Image Generation",
    videoGeneration: "Video Generation",
    presentation: "Presentation",
    buuAgent: "Buu Digital Agent Chat",
    agent: "Agent",
    character: "Character",
    dataMining: "Data Mining",
    audioGeneration: "Audio Generation",
    musicGeneration: "Music Generation",
  },
  memory: {
    helpText: "Set memory",
    prompt: "Set memory (0-1000):",
  },
  modelInfo: {
    all: "All",
    close: "Close",
    loadMore: "Load more",
    filterByCapability: "Filter by capacity",
    filterByProvider: "Filter by provider",
    showDisabled: "Show disabled",
    free: "Free",
    disabled: "Disabled",
    helpText: "Model information",
    title: "Integrated Services Pricing",
    description: "Model description",
    capabilities: "Capabilities",
    inputCost: "Input cost per 1M tokens:",
    outputCost: "Output cost per 1M tokens:",
    costPerGeneration: "Cost per event:",
    sortByCost: "Sort by cost",
    costLowToHigh: "Cost: Low to High",
    costHighToLow: "Cost: High to Low",
    notice:
      "Some models may have regional restrictions based on provider policies. Free models have daily usage limits.",
    pricing: {
      perMillion: "per 1M tokens",
    },
    toolCalling: "Tool calling",
    reasoning: "Reasoning",
    vision: "Vision",
    embedding: "Embedding",
    image: "Image",
    video: "Video",
    chat: "Chat",
    music: "Music",
    multimodal: "Multimodal",
    textToSpeech: "Text to Speech",
    reranking: "Reranking",
    dataMining: "Data Mining",
  },
  imageSettings: {
    helpText: "Image settings",
    title: "Image settings",
    modelSearch: "Search models on CivitAI",
    viewModelOnCivitai: "View model on CivitAI",
    selectedRunwareModel: "Selected Runware model",
    negativePromptToggle: "Show negative prompt",
    negativePrompt: "Negative prompt",
    negativePromptHelpText:
      "A negative prompt is a phrase that the model should avoid. For example, if you want an image of a dog, you don't want an image of a cat, so the negative prompt would be 'cat'.",
    negativePromptPlaceholder: "Enter negative prompt...",
    hd: "HD",
    size: "Size",
    sizeHelpText:
      "Adjust the dimensions of the generated image by specifying its width and height in pixels, or select from the predefined options. Image dimensions must be multiples of 64 (e.g., 512x512, 1024x768).",
    format: "Format",
    numImages: "Number of images",
    numImagesHelpText:
      "Specify how many images to generate in a single request. Each image generation will be charged separately.",
    width: "Width",
    height: "Height",
    steps: "Steps",
    stepsHelpText:
      "Steps are the iterations a model goes through to generate an image. The number of steps determines the quality and detail of the image, but it also increases the time/cost to generate the image",
    cfgScale: "Cfg Scale",
    cfgScaleHelpText:
      "Adjusts how closely the generated image aligns with the input prompt. A higher value enforces stronger adherence to the prompt, while a lower value allows for more creative freedom.",
    scheduler: "Scheduler",
    schedulerHelpText:
      "Select the method used to control the image generation process. Different schedulers influence how the model approaches refining the image, affecting style and quality.",
    seed: "Seed",
    seedHelpText:
      "A random number used to seed the image generation process, to have consistent/similar results, set the same seed for the same prompt.",
    strength: "Strength",
    strengthHelpText: "Strength for image generation",
    advancedControls: "Advanced controls",
    decorType: "Decor type",
    decorTypeHelpText:
      "Select Prime for wall finishes, Stage for interior decoration",
    uploadImage: "Upload image",
    uploadReferenceImage: "Upload reference image",
    imageUrl: "Image URL",
    dragAndDrop: "Drag and drop to add image",
    roomType: "Room type",
    roomTypes: {
      livingroom: "Livingroom",
      kitchen: "Kitchen",
      diningroom: "Diningroom",
      bedroom: "Bedroom",
      bathroom: "Bathroom",
      kidsroom: "Kidsroom",
      familyroom: "Familyroom",
      readingnook: "Readingnook",
      sunroom: "Sunroom",
      walkincloset: "Walkincloset",
      mudroom: "Mudroom",
      toyroom: "Toyroom",
      office: "Office",
      foyer: "Foyer",
      powderroom: "Powderroom",
      laundryroom: "Laundryroom",
      gym: "Gym",
      basement: "Basement",
      garage: "Garage",
      balcony: "Balcony",
      cafe: "Cafe",
      homebar: "Homebar",
      study_room: "Study room",
      front_porch: "Front porch",
      back_porch: "Back porch",
      back_patio: "Back patio",
    },
    designStyle: "Design style",
    designStyles: {
      minimalist: "Minimalist",
      scandinavian: "Scandinavian",
      industrial: "Industrial",
      boho: "Boho",
      traditional: "Traditional",
      artdeco: "Art Deco",
      midcenturymodern: "Midcentury Modern",
      coastal: "Coastal",
      tropical: "Tropical",
      eclectic: "Eclectic",
      contemporary: "Contemporary",
      frenchcountry: "French Country",
      rustic: "Rustic",
      shabbychic: "Shabby Chic",
      vintage: "Vintage",
      country: "Country",
      modern: "Modern",
      asian_zen: "Asian Zen",
      hollywoodregency: "Hollywood Regency",
      bauhaus: "Bauhaus",
      mediterranean: "Mediterranean",
      farmhouse: "Farmhouse",
      victorian: "Victorian",
      gothic: "Gothic",
      moroccan: "Moroccan",
      southwestern: "Southwestern",
      transitional: "Transitional",
      maximalist: "Maximalist",
      arabic: "Arabic",
      japandi: "Japandi",
      retrofuturism: "Retrofuturism",
      artnouveau: "Art Nouveau",
    },
    colorScheme: "Color scheme",
    specialityDecor: "Speciality decor",
    scaleFactor: "Scale factor",
    colorSchemes: {
      colorScheme0: "Default",
      colorScheme1: "Moss Green, Tan, White",
      colorScheme2: "Gray, Sand, Blue",
      colorScheme3: "Hunter Green, Red",
      colorScheme4: "White, Pops of Color",
      colorScheme5: "Blue, Neon",
      colorScheme6: "Light Blue, Emerald",
      colorScheme7: "Blue, Grass Green",
      colorScheme8: "Blue, Beige",
      colorScheme9: "Gray, Brown",
      colorScheme10: "Black, Red",
      colorScheme11: "Gray-Green, White, Black",
      colorScheme12: "Blue, Gray, Taupe",
      colorScheme13: "Black, Navy",
      colorScheme14: "Emerald, Tan",
      colorScheme15: "Forest Green, Light Gray",
      colorScheme16: "Yellow, Gray",
      colorScheme17: "Pink, Green",
      colorScheme18: "Blush Pink, Black",
      colorScheme19: "Black, White",
      colorScheme20: "Blue, White",
    },
    specialityDecors: {
      specialityDecor0: "None",
      specialityDecor1:
        "Halloween Decor with Spooky Ambiance, Eerie Elements, Dark Colors, and Festive Accents",
      specialityDecor2:
        "Christmas Decor with Christmas Tree, Ornaments, and Lights",
      specialityDecor3: "Thanksgiving Decor, Fall Season Decor",
      specialityDecor4: "Fall Season Decor",
      specialityDecor5: "Spring Season Decor",
      specialityDecor6: "Summer Season Decor",
      specialityDecor7: "Winter Season Decor",
    },
  },
  newSession: "New Session",
  newChat: "New Chat",
  temperature: {
    helpText: "Set temperature",
    prompt: "Set temperature (0-2):",
  },
  you: "You",
  ai: "AI",
  system: "System",
  deleteMessage: "Delete message",
  systemMessageUpdated: "System prompt updated successfully",
  deleteSession: "Delete session",
  renameSession: "Rename session",
  sessionNamePlaceholder: "Enter session name...",
  sendMessage: "Send message",
  expand: "Expand input",
  collapse: "Collapse input",
  credits: {
    view: "View Usage Details",
    balance: "Credits: ${{amount}}",
  },
  numChats: {
    select: "Select the number of chats you want to have in this session",
    reset: "Reset",
    warning:
      "Changing the amount of columns will reset the comparative chat, ALL MESSAGES WILL BE LOST, are you sure?",
  },
  errors: {
    creditsExceeded:
      "You have exceeded your credits limit. Please upgrade your subscription or add credits to continue using the service.",
    generic:
      "An error occurred while generating the response. Please try again.",
    failed: "Failed to send message",
  },
  agentChat: {
    changeAgent: "Change Agent",
  },
};
